// Vuetify plugin setup for Medispace UI
// Theme colors can be updated at runtime via useProjectConfig (loads project.json palette)
import 'vuetify/styles';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

const medispaceLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#4182D8',
    secondary: '#6B7280',
    success: '#22C55E',
    warning: '#F59E0B',
    error: '#DC2626',
    background: '#FFFFFF',
    surface: '#F5F7FA',
    'on-surface': '#111827',
    'on-primary': '#FFFFFF',
    'on-secondary': '#FFFFFF',
    'on-success': '#052E16',
    'on-warning': '#451A03',
    'on-error': '#FFFFFF',
    'focus-ring': '#2E5FA8',
    'deep-blue': '#2E5FA8',
    'soft-blue': '#E8F1FB',
    'neutral-gray': '#6B7280',
    'light-gray': '#F5F7FA',
  },
};

const medispaceDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: '#4182D8',
    secondary: '#9CA3AF',
    success: '#22C55E',
    warning: '#F59E0B',
    error: '#F87171',
    background: '#0F172A',
    surface: '#111827',
    'on-surface': '#F9FAFB',
    'on-primary': '#FFFFFF',
    'on-secondary': '#111827',
    'on-success': '#052E16',
    'on-warning': '#451A03',
    'on-error': '#111827',
    'focus-ring': '#93C5FD',
    'deep-blue': '#2E5FA8',
    'soft-blue': '#1E293B',
    'neutral-gray': '#9CA3AF',
    'light-gray': '#374151',
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'medispaceLightTheme',
    themes: {
      medispaceLightTheme,
      medispaceDarkTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
  defaults: {
    VBtn: {
      rounded: 'xl',
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class: 'text-none medispace-focus-ring',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class: 'medispace-focus-ring',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class: 'medispace-focus-ring',
    },
    VCheckbox: {
      density: 'comfortable',
      rounded: 'lg',
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class: 'medispace-focus-ring',
    },
    VRadio: {
      density: 'comfortable',
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class: 'medispace-focus-ring',
    },
    VCard: {
      rounded: 'xl',
      elevation: 0,
      style: 'outline: 2px solid transparent; outline-offset: 2px;',
      class: 'medispace-card medispace-focus-ring',
    },
  },
});
